import React, { useEffect, useState } from 'react';
import { BsFillInfoCircleFill, BsArrowRepeat } from 'react-icons/bs';
import { Tooltip } from 'react-tooltip';
import { locales } from '../../translations/locales';

const Lobby = (props) => {
    const { data, ModuleRP, locale, theme } = props;
    const [gamesList, setGamesList] = useState([]);

    useEffect(() => {
        const sortData = () => {
            for (let i = 0; i < data.length; i++) {
                const game = data[i];
                if (game.players.some((e) => e.name === ModuleRP.userName) ||
                    !game.isPublic ||
                    !game.recruitmentOpen
                ) {
                    data.splice(i, 1);
                    return sortData();
                } else {
                    if (game.waitingPlayers.some((e) => e.name === ModuleRP.userName)) {
                        game.waiting = true;
                    } else {
                        game.waiting = false;
                    }
                }
            }
            const sortedList = data.sort((a, b) => {
                return b.players.length - a.players.length;
            });
            setGamesList(sortedList);
        };
        sortData();
    }, [gamesList, data]);

    return (
        <div className='lobby container m-1 overflow-auto' id='lobby'>
            <div className={`bg-${theme === 'DARK' ? 'dark' : 'light'} w-100 text-${theme === 'DARK' ? 'light' : 'dark'} text-center`}>
                <h2>
                    {locales[locale].gamesTable.titleGames}
                </h2>
            </div>

            <table className={`table table-hover table-${theme === 'DARK' ? 'dark' : 'light'}`}>
                <thead>
                    <tr>
                        <th>{locales[locale].gamesTable.gameNames}</th>
                        <th>{locales[locale].gamesTable.gameDescription}</th>
                        <th>{locales[locale].gamesTable.gamePlayersNb}</th>
                        <th><BsArrowRepeat id='refreshList' className='float-right cursor-pointer' data-tip data-tooltip-id='refreshList' onClick={() => {
                            ModuleRP.setPage('Logo', locales[locale].loading); ModuleRP.getAllGames();
                        }} />
                            <Tooltip id='refreshList' place='top' effect='solid' className='text-center'>
                                {locales[locale].refresh}
                            </Tooltip>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {
                        gamesList.length > 0 ?
                            gamesList.map((game) =>
                            (<tr key={game.id}>
                                <td>{game.name}</td>
                                <td>{game.description}</td>
                                <td>{game.players.length}
                                    <span data-tip data-tooltip-id={'playersList_' + game.id}>
                                        {<BsFillInfoCircleFill className='m-1' />}
                                    </span>
                                    <Tooltip
                                        key={game.id}
                                        id={'playersList_' + game.id}
                                        place='right'
                                        effect='solid'
                                        className='text-center'
                                        data-html={true}
                                    >
                                        {game.players.map((player) => (
                                            <div key={player.id + '_' + game.id}>{player.name}</div>
                                        ))}
                                    </Tooltip>
                                </td>
                                <td>
                                    {
                                        game.waiting ? (
                                            <button
                                                className='btn btn-sm btn-danger float-right'
                                                id={'btn-cancelJoin-' + game.id}
                                                onClick={() => ModuleRP.cancelRequestJoin(game.id)}
                                            >
                                                {locales[locale].gamesTable.cancelJoin}
                                            </button>
                                        ) : (
                                            <button
                                                className='btn btn-sm btn-success float-right'
                                                id={'btn-sendJoin-' + game.id}
                                                onClick={() => ModuleRP.sendRequestJoin(game.id)}
                                            >
                                                {locales[locale].gamesTable.join}
                                            </button>
                                        )
                                    }
                                </td>
                            </tr>),
                            ) : (
                                <tr>
                                    <td colSpan={4}>{locales[locale].gamesTable.noGameToJoin}</td>
                                </tr>
                            )
                    }
                </tbody>
            </table>
        </div>
    );
};

export default Lobby;
